/* eslint-disable */
// @ts-nocheck
import { MICRO_FRONTENDS_CONFIG, MICRO_FRONTEND_VERSIONS } from '../actions/MicroFrontendActions';
import { reducerWrapper } from '../support/utils';
import type { MicroFrontendsReducer } from '../types/microFrontendReducerTypes';

export const INIT_STATE: MicroFrontendsReducer = {
  versions: {},
  isLoading: true,
  qlt: {
    url: null,
  },
  journeysCreativesOptimization: {
    url: null,
  },
  postbacksForm: {
    url: null,
  },
  linkManager: {
    url: null,
  },
  alertNotifications: {
    url: null,
  },
  qrCodeCustomizations: {
    url: null,
  },
  usage: {
    url: null,
  },
  discoDashboard: {
    url: null,
  },
};

/* eslint-disable @typescript-eslint/default-param-last*/
export function Handler(
  state: MicroFrontendsReducer = INIT_STATE,
  action: {
    type: string;
    data: any;
  }
): MicroFrontendsReducer {
  switch (action.type) {
    case MICRO_FRONTENDS_CONFIG.response:
      return {
        ...state,
        qlt: action?.data?.qlt,
        journeysCreativesOptimization: action?.data?.journeysCreativesOptimization,
        postbacksForm: action?.data?.postbacksForm,
        linkManager: action?.data?.linkManager,
        alertNotifications: action?.data?.alertNotifications,
        qrCodeCustomizations: action?.data?.qrCodeCustomizations,
        usage: action?.data?.usage,
        discoDashboard: action?.data?.discoDashboard,
        isLoading: false,
      };
    case MICRO_FRONTEND_VERSIONS.response:
      return {
        ...state,
        versions: action?.data,
        isLoading: false,
      };
    default:
      return state;
  }
}

const MicroFrontends = reducerWrapper(INIT_STATE, Handler, {
  request: [MICRO_FRONTENDS_CONFIG],
  error: [],
  resetOn: [],
});

export default MicroFrontends;
